import "../../../styles/dashboard.css";


import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate,useLocation } from "react-router";

import api from "../../../../../api/api";

import Welcome from "../../../../../components/popup/Welcome";
import { useAuth } from "../../../../../features/auth/AuthContext";
import { updateGlobalState } from "../../../../../state/global/slice";
import PopupSection from "../Dashboard_popup";
import "aos/dist/aos.css";
import UniversalChatbot from "../../../../../components/universalChatbot/UniversalChatbot";
import { changeScrollPopup } from "../../../../../utils/utlis";


import Message from "../../../../../modules/teacher/message/Message";
import DashboardMain from "../../../../../modules/teacher/dashboard/DashboardMain";
import TeacherHome from "./Tab/TeacherHome";
import Settings from "../../settings/Settings";
import { setDrawerState, setIsWebAllowed, setQueryMetaData } from "../../../../../state/reducers/chatDrawerReducers";
import FloatingAIButton from "../../../../../components/FloatingAIButton/FloatingAIButton";
import CustomSingleButtonPopup from "../../../../../components/CustomSingleButtonPopup/CustomSingleButtonPopup";
import { copyLessons_loaderGif } from "../../../../../assets/images/images";


const TeacherDashboard = ({ tabList, activeTab, setActiveTab }) => {
  const { logout, token } = useAuth();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const updateState = (key, value) => {
    dispatch(updateGlobalState({ key: key, value: value }));
  };
  const chatDrawerState = useSelector((state) => state?.ChatDrawerState);
  const [courseLoading, setcourseLoading] = useState(false)
  const [getDashboardCount, setgetDashboardCount] = useState({});
  const [dashboardCountLoading, setdashboardCountLoading] = useState(false);
  const [fullteacherdetails, setfullteacherdetails] = useState({});
  const globalState = useSelector((state) => state.globalState);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [nextUrl, setNextUrl] = useState(null);
  const [sessionExpired, setSessionExpired] = useState(false);
  const [prevUrl, setPrevUrl] = useState(null);
  const updateCoursePage = (page) => {
    setCurrentPage(page);
  };
  const updateCoursePageTotal = (total) => {
    setTotalPages(total);
  };
const isDuplicatingCourse = useSelector(
  (state) => state.globalState.isDuplicatingCourse,
);
  const handlePageChange = (event, value) => {
    updateCoursePage(value);
  };

const location=useLocation()
  const getPaginatedCourseList = async (page) => {
    updateCoursePage(page);
    const teacher_id = globalState.teacher_details?.data?.teacher_id ?? "";
    const url = `/courses/get-all-courses/teacher/${teacher_id}/?page=${page}`;
    setcourseLoading(true);
    api
      .get(url, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Token ${token}`,
        },
      })
      .then((response) => {
        if (Number(response.status) === 200) {
          setcourseLoading(false)
          if (response?.data) {
            const totalItems =
              Number(JSON.parse(JSON.stringify(response?.data))?.count) ?? 0;
            const totalPages = Math.ceil(totalItems / 12);
            updateState(
              "course_list",
              JSON.parse(JSON.stringify(response?.data))?.data ?? []
            );
            updateState(
              "total_course",
              totalItems
            );

            updateCoursePageTotal(totalPages);
            const data = response.data;
            setNextUrl(data?.next); // Update next URL
            setPrevUrl(data?.previous); // Update previous URL
          }
        }
      })
      .catch((error) => { setcourseLoading(false) });
    // .catch((error) => { });
  };
  useEffect(() => {
    // https://web.mycro.news/auth/check-user/?email=vaibhava@webarcitech.com
    const url = `auth/check-user/?email=${encodeURIComponent(globalState?.email) || ""}`;
    const headers = {
      "Content-Type": "application/json",
    };
    api
      .get(
        url,
        { headers }
      ).catch((error) => {
        // logout() already redirects. The relative navigate('login') that used
        // to follow resolved against the current route (e.g. /dashboard/login)
        // and raced the redirect.
        if (error?.response?.data?.status === 400) {
          logout("/login");
        }
      });



    api
      .get("/auth/get-teacher/", {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Token ${token}`,
        },
      })
      .then((response) => {
        if (response.status === 200) {
          if (response?.data) {
            updateState("teacher_details", response?.data ?? {});
          }
          setfullteacherdetails(response.data);
          // Remove duplicate API call - courses will be fetched by getPaginatedCourseList
          setWelcomePopupStatus(false);
          setProfilePopupStatus(false);
          localStorage.setItem("is_profile", "true");
        } else {
          setWelcomePopupStatus(false);
        }
      })
      .catch((error) => {
        if (error?.response?.status === 401) {
          setSessionExpired(true)
          return
        }
        setWelcomePopupStatus(false);
        // setProfilePopupStatus(true);
      });
    api
      .get("/auth/get-datalist/", {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Token ${token}`,
        },
      })
      .then((response) => {
        if (response.status === 200) {
          updateState("datalist", response?.data ?? {});
        }
      })
      .catch((error) => { });
    api
      .get("/courses/get-grade-list/", {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Token ${token}`,
        },
      })
      .then((response) => {
        if (response.status === 200) {
          if (response?.data) {
            updateState("grade_details", response?.data ?? {});
          }
        }
      })
      .catch((error) => { });

    setdashboardCountLoading(true)
    api
      .get("/auth/teacher-dashboard-count/", {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Token ${token}`,
        },
      })
      .then((response) => {
        if (response.status === 200) {
          if (response?.data) {
            setgetDashboardCount(response?.data);
            if(response?.data?.data?.currency_symbol) {
            updateState("currency_symbol", response?.data?.data?.currency_symbol)
            }
            setdashboardCountLoading(false)
          }
        }
      })
      .catch((error) => { setdashboardCountLoading(false) });
  }, []);

  // Add useEffect to fetch courses when teacher details are available
  useEffect(() => {
    if (globalState.teacher_details?.data?.teacher_id) {
      getPaginatedCourseList(currentPage);
      window.scrollTo(0, 0);
    }
  }, [globalState.teacher_details?.data?.teacher_id, currentPage]);

  const profileName = fullteacherdetails?.data?.name;

  const onProfileClick = () => {
    setActiveTab("Settings");
  };

  const getActiveTab = () => {
    switch (activeTab) {
      case tabList[0].key:
        return (
          <DashboardMain
            profileFirstName={profileName}
            handlePageChange={handlePageChange}
            totalPages={totalPages}
            currentPage={currentPage}
            nextUrl={nextUrl}
            prevUrl={prevUrl}
            showCourse={showCourse}
            setShowCourse={setShowCourse}
            toggleCourse={toggleCourse}
            getDashboardCount={getDashboardCount}
            setgetDashboardCount={setgetDashboardCount}
          />
        );
      case tabList[1].key:
        return <Message />;
      case tabList[2].key:
        return <Settings isDashboard={true} />;
      default:
        return <DashboardMain />;
    }
  };
  const [welcomePopupStatus, setWelcomePopupStatus] = useState(false);
  // const [profilePopupStatus, setProfilePopupStatus] = useState(false);
   const [profilePopupStatus, setProfilePopupStatus] = useState(() => {
      try {
        // Show the popup when the profile is not yet completed (is_profile === false)
        return !Boolean(JSON.parse(localStorage.getItem("is_profile") || "false"));
      } catch {
        return true;
      }
    });
  const [showCourse, setShowCourse] = useState(false);

  const toggleCourse = (overflow) => {
    setShowCourse(!showCourse);
  };

  useEffect(() => {
    if (welcomePopupStatus === true) {
      changeScrollPopup("hidden", "welcome-polly-popup-wrapper");
    } else {
      changeScrollPopup("auto", "welcome-polly-popup-wrapper");
    }
  }, [welcomePopupStatus]);

  const handleCancelPopup = () => {
    logout();
    setSessionExpired(false);
  };

  return (
    <>
      {sessionExpired === true && <CustomSingleButtonPopup
        title={'Your session has expired. Please log in again to continue.'}
        btn1={'Login'}
        btn1Click={handleCancelPopup}
      />}
      {welcomePopupStatus === true && (
        <Welcome setWelcomePopupStatus={setWelcomePopupStatus} />
      )}
      {profilePopupStatus === true && (
        <PopupSection
          profilePopupStatus={profilePopupStatus}
          welcomePopupStatus={welcomePopupStatus}
          setWelcomePopupStatus={setWelcomePopupStatus}
          setProfilePopupStatus={setProfilePopupStatus}
        />

      )}
      {/* <UniversalChatbot /> */}

      <TeacherHome
        profileFirstName={profileName}
        handlePageChange={handlePageChange}
        totalPages={totalPages}
        currentPage={currentPage}
        nextUrl={nextUrl}
        prevUrl={prevUrl}
        showCourse={showCourse}
        setShowCourse={setShowCourse}
        toggleCourse={toggleCourse}
        getDashboardCount={getDashboardCount}
        courseLoading={courseLoading}
        setgetDashboardCount={setgetDashboardCount}
        dashboardCountLoading={dashboardCountLoading}
        setdashboardCountLoading={setdashboardCountLoading}
      />
      {
        !profilePopupStatus &&
        <FloatingAIButton
          onClick={() => {
            dispatch(setDrawerState(!chatDrawerState.isOpen));
            dispatch(setIsWebAllowed(true));
            dispatch(setQueryMetaData(null));
          }}
        />
      }
      {isDuplicatingCourse && (
              <div className="fixed inset-0 z-[999999] flex items-center justify-center  px-4">
                <div className="bg-white rounded-2xl shadow-xl w-full max-w-[320px] min-h-[220px] flex flex-col items-center justify-center p-6">
                  <div className="w-[100px] h-[60px] flex items-center justify-center">
                    <img
                      src={copyLessons_loaderGif}
                      alt="transferring"
                      className="w-full h-full object-contain"
                    />
                  </div>
      
                  <p className="mt-5 text-[16px] sm:text-[18px] font-semibold text-[#2B2B2B] text-center leading-[24px]">
                    Duplicating Your Course.
                    <span className="font-normal"> This may take a moment...</span>
                  </p>
                </div>
              </div>
            )}
    </>
  );
};

export default TeacherDashboard;